export const DRIPSET_LOGO = '/public/images/logo.png'
export const EMSENSE_LOGO = '/public/images/emsense_logo.png'

// Onboarding
export const SLIDE_ONE = '/public/images/onboarding_01.png'
export const SLIDE_TWO = '/public/images/onboarding_02.png'
export const SLIDE_THREE = '/public/images/onboarding_03.png'

// User Role
export const INDIVIDUAL_SRC = '/public/images/individual.png'
export const NURSE_SRC = '/public/images/nurse.png'
export const HOSPITAL_SRC = '/public/images/hospital.png'

// TOTP
export const TOTP_SRC = '/public/images/google_otp.png'

// Dashboard
export const SORT_SRC = '/public/images/sort.png'

// OTP
export const OTP_SRC = '/public/images/otp.png'
export const OTP_EMAIL_SRC = '/public/images/verify_email.png'
export const OTP_MOBILE_SRC = '/public/images/verify_mobile.png'

//USER
export const ADD_USER_NURSWE_SRC = '/public/images/nurse_1.png'
export const ADD_USER_HOSPITAL_SRC = '/public/images/hospital_1.png'

export const ADD_DEVICE_DRIPSET_SRC = '/public/images/ADD_DEVICE.png'
export const DEVICE_LIST_SRC = '/public/images/device_list.png'
export const DEVICE_LIST_IMAGE_SRC = '/public/images/device_list_image.png'
export const DRIPSET_DEVICE_SRC = '/public/images/dripset.png'
export const MOBILE_DEVICE_SRC = '/public/images/mobile_device.png'


export const VOLUME_IMAGE_SRC = '/public/images/value.png'
export const DOOR_IMAGE_SRC = '/public/images/door.png'
export const BED_IMAGE_SRC = '/public/images/single_bed.png'

export const HOSPITAL_APPROVED_IMAGE_SRC = '/public/images/hospital_approved.png'
export const HOSPITAL_CANCELLED_IMAGE_SRC = '/public/images/hospital_cancelled.png'
export const HOSPITAL_REVIEWED_IMAGE_SRC = '/public/images/hospital_reviewed.png'

export const NURSE_APPROVED_IMAGE_SRC = '/public/images/nurse_approved.png'
export const NURSE_CANCELLED_IMAGE_SRC = '/public/images/nurse_cancelled.png'
export const NURSE_REVIEWED_IMAGE_SRC = '/public/images/nurse_reviewed.png'

export const REPORT_IMAGE_SRC = '/public/images/report.png'

export const DEFAULT_PROFILE_SRC = '/public/images/default_profile.jpg'





